import { Nullable } from '@/shared/types/app.types'

export const SCIENTIFIC_ANALYSIS_NHC_CENTER = 'identifierType.NHC'
export const SCIENTIFIC_ANALYSIS_IDENTIFIER_TYPE_FIELD_SEPARATOR = '_'

export interface ScientificAnalysisIdentifierType {
    code: string
    idtId: number
    idtScope: string
}

export interface ScientificAnalysisCenter {
    active: boolean
    code: string
    id: number
    name: string
}

export interface ScientificAnalysisFilterPanelSelectPatientIdentifierState {
    centers: ScientificAnalysisCenter[],
    centerSelected: Nullable<ScientificAnalysisCenter>,
    patientIdentifierOptions: ScientificAnalysisIdentifierType[],
    identifierSelected: Nullable<ScientificAnalysisIdentifierType>
    asyncSearch: boolean
}
export const initialScientificAnalysisFilterPanelSelectPatientIdentifierState =
    (): ScientificAnalysisFilterPanelSelectPatientIdentifierState => ({
        centers: [],
        centerSelected: null,
        patientIdentifierOptions: [],
        identifierSelected: null,
        asyncSearch: false
    })
